import filters from '../../filters.json';

const categoryFilterPrecedence = [
    'US Equity',
    'International Equity',
    'Sector Equity',
    'Taxable Bond',
    'Municipal Bond',
    'Allocation',
    'Money Market',
    'Alternative'
];

const indexOf = (arr, i) => {
    const res = arr.indexOf(i);
    return res < 0 ? Infinity : res;
};

const sortByPrecedence = (arr) =>
    arr.sort(
        (a, b) =>
            indexOf(categoryFilterPrecedence, a.label) -
            indexOf(categoryFilterPrecedence, b.label)
    );

export const hydrateCategoryFilter = (data) => {
    const { allMutualFunds } = data;
    if (!allMutualFunds) return [];
    const unique = [
        ...new Set(allMutualFunds.map((ele) => `${ele.broadAssetClass}`))
    ];

    const items = unique.map((ele) =>
        [
            ...new Set(
                allMutualFunds
                    .filter((e) => e.broadAssetClass === ele)
                    .map((ee) => `${ee.morningStarCategoryName}`)
            )
        ]
            .map((e) => ({ label: e, itemField: 'morningStarCategoryName' }))
            .sort((a, b) => `${a.label}`.localeCompare(b.label))
    );
    const returnVal = unique
        .map((ele, i) => ({
            label: ele,
            field: 'broadAssetClass',
            items: items[i]
        }))
        .sort((a, b) => `${a.label}`.localeCompare(b.label));

    return sortByPrecedence(returnVal);
};

export const FundCategoryFilters = Object.values(
    filters['Fund Type Categories']
).reduce((acc, value) => ({ ...acc, ...value }), {});
